import { render, staticRenderFns } from "./mxorder.vue?vue&type=template&id=65b9f4e3&"
import script from "./mxorder.vue?vue&type=script&lang=js&"
export * from "./mxorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports